import { type FC } from 'react';

interface CancelOrderModalProps {
    isOpen: boolean;
    orderRef: string;
    onClose: () => void;
    onConfirm: () => void;
    isSubmitting: boolean;
}

const CancelOrderModal: FC<CancelOrderModalProps> = ({ isOpen, orderRef, onClose, onConfirm, isSubmitting }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-stone-900/50 backdrop-blur-sm">
            <div className="bg-white rounded-2xl shadow-xl border border-stone-200 w-full max-w-md overflow-hidden animate-in fade-in zoom-in duration-200">
                <div className="p-6">
                    <div className="w-12 h-12 rounded-full bg-[#e6186c]/20 flex items-center justify-center mb-4">
                        <svg className="w-6 h-6 text-[#e6186c]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                    </div>
                    <h3 className="text-xl font-semibold text-stone-900">Cancel Order</h3>
                    <p className="text-sm text-stone-500 mt-2">
                        Are you sure you want to cancel order <span className="font-semibold text-stone-800">{orderRef}</span>?
                        This action will be logged in the audit trail and cannot be undone.
                    </p>
                </div>
                <div className="bg-stone-50 p-4 flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        disabled={isSubmitting}
                        className="px-4 py-2 text-sm font-medium text-stone-600 hover:text-stone-900 disabled:opacity-50"
                    >
                        Keep Order
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={isSubmitting}
                        className="px-4 py-2 text-sm font-medium bg-red-600 text-white rounded-lg hover:bg-red-700 shadow-sm disabled:opacity-50 flex items-center gap-2"
                    >
                        {isSubmitting ? 'Cancelling...' : 'Confirm Cancellation'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CancelOrderModal;